import eventQueue from '../queue';
import { EventAction, EventSurface } from '../../types/events';
function attachEventListeners() {
    // eslint-disable-next-line consistent-return
    eventQueue.on('link_api_action', function (_a) {
        var action = _a.action, fireAnalyticsEvent = _a.fireAnalyticsEvent, state = _a.state;
        if (action.actionType === 'callback' &&
            state.segment.currentSource === EventSurface.LOGIN) {
            return fireAnalyticsEvent(EventAction.INCORRECT_PLATFORM);
        }
    });
}
attachEventListeners();
